import { Fragment, useRef } from "react"
import Modal from '@/react/libraries/Modal'
import { useTableMetadataStore } from "../../_stores"
import axios from "axios"
import $ from "jquery"

import ToasterWrapper from '@/react/components/ToasterWrapper'

const { toast } = ToasterWrapper

const BASE_URL = window.BASE_URL

function ColumnEdit({
	buttonRef,
	metaKey
}) {
	const modalRef = useRef(null)

	const columns = useTableMetadataStore(state => state.columns)
	const setColumnVisibility = useTableMetadataStore(state => state.setColumnVisibility)

	return (
		<Modal modalTriggerRef={buttonRef} ref={modalRef} className="modal__content-wrapper p-2">
			<div class="modal__content-wrapper-header">
				<h2>
					Customize columns
				</h2>
			</div>
			<div class="modal__content-wrapper-body">
				<div id="column-picker"
					className="text-center grid grid-cols-2 items-center justify-center border-grey rounded-primary border-thick max-h-[600px] overflow-y-auto 
		[&>h2]:text-base [&>h2]:font-semibold [&>h2]:border-b-thin [&>h2]:border-grey [&>h2]:py-5 [&>h2]:sticky [&>h2]:top-0 [&>h2]:bg-white [&>h2]:z-10
		[&>p]:py-5 
		[&>*:nth-child(odd)]:border-r-thin [&>*:nth-child(odd)]:border-grey
		[&>input]:justify-self-center
		">
					<h2>Columns</h2>
					<h2>Show</h2>
					{columns.map((column, i) => (
						<Fragment key={i}>
							<p>{column.heading}</p>
							<input type="checkbox" checked={column.isVisible} onChange={(e) => setColumnVisibility(column.index, e.target.checked)} />
						</Fragment>
					))}
				</div>
			</div>
			<div class="modal__content-wrapper-footer">
				<button className="btn" onClick={async (e) => {
					const columnNamesArray = []

					// get the column names of the visible columns
					columns.forEach(column => {
						if (column.isVisible) columnNamesArray.push(column.heading)
					})
					window.__.loaderButtonInit(e.target)

					const response = await axios.get(BASE_URL + `admin/meta-fields/${metaKey}`, {
						headers: {
							'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
							'Content-Type': 'application/json'
						},
						params: {
							columns: JSON.stringify(columnNamesArray)
						},
					})

					e.target.finishLoading()

					if (response.status === 201 || response.status === 200) {
						modalRef.current.closeModal()
						toast.success('Columns updated')
					} else {
						toast.error('Something went wrong')
					}

				}}>
					Save Changes
				</button>
			</div>
		</Modal>
	)
}

export default ColumnEdit